import React from 'react';
import type { SessionScreen } from '../../../features/flow/session';
import type { ScreenQuestion } from '../../../features/flow/types';
import { cleanTitle } from '../../../features/flow/utils';

export function TaxDraftReadyScreenBody({
  sessionScreen,
  questions,
  onContactUs,
}: {
  sessionScreen: SessionScreen;
  questions: ScreenQuestion[];
  onContactUs?: () => void;
}) {
  const title = cleanTitle(sessionScreen.title ?? '');
  const subtitle = (sessionScreen.subtitle ?? '').trim();
  const paragraphs = Array.isArray(sessionScreen.paragraphs) ? sessionScreen.paragraphs.filter((p) => String(p).trim() !== '') : [];

  // Placeholder preview block: backend may later provide a file link/value.
  // For now we always render the space and a Download button.
  const hasReviewFiles = questions.some((q) => q.field_type === 'review_files');

  return (
    <div className="w-full flex flex-col items-start gap-6">
      <div className="w-full max-w-[535px] flex flex-col items-start text-start gap-4">
        <h1 className="text-lg md:text-[22px] lg:text-2xl font-medium md:font-semibold text-[#131315]">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-[#525353] text-base w-full font-medium">{subtitle}</p>
        ) : null}

        {paragraphs.length > 0 ? (
          <div className="flex flex-col gap-1.5 text-[#525353] text-base font-medium">
            {paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        ) : null}
      </div>

      {hasReviewFiles ? (
        <div className="w-full rounded-xl bg-[#D9D9D9] min-h-[280px] md:min-h-[320px] relative overflow-hidden">
          <button
            type="button"
            className="absolute right-6 top-6 h-[40px] px-4 py-2 rounded-lg border border-[#939393] bg-white text-sm font-semibold text-[#131315]"
          >
            Download
          </button>
        </div>
      ) : null}

      {onContactUs ? (
        <button
          type="button"
          onClick={onContactUs}
          className="hidden"
          aria-label="Contact us"
        />
      ) : null}
    </div>
  );
}

